module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ec14005976de0c416291669942e660b9.png";